import { render } from "./guided-tours.vue?vue&type=template&id=5f719c0f&ts=true"
import script from "./guided-tours.vue?vue&type=script&lang=ts"
export * from "./guided-tours.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__